(() => {
  const pairs = [
    ['company_name', 'shipping_address_recipient'],
    ['first_name', 'shipping_address_first_name'],
    ['last_name', 'shipping_address_last_name'],
    ['phone_number', 'shipping_address_phone']
  ];
  const bound = new WeakSet();
  const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  function connect(root) {
    const company = root.getElementById('company_name');
    const form = company?.closest('form');
    if (!form || !pairs.every(([source, target]) => root.getElementById(source) && root.getElementById(target))) return;
    const label = root.getElementById('label-company_name');
    if (label && label.textContent !== 'Butikkens navn') label.textContent = 'Butikkens navn';
    if (!root.querySelector('style[data-block-it-registration]')) {
      const style = document.createElement('style');
      style.dataset.blockItRegistration = '';
      style.textContent = '[data-block-it-repeat]{display:none!important}';
      root.append(style);
    }
    function synchronize() {
      for (const [sourceId, targetId] of pairs) {
        const source = root.getElementById(sourceId);
        const target = root.getElementById(targetId);
        if (!source || !target) continue;
        if (target.value !== source.value) {
          setValue.call(target, source.value);
          target.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
          target.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        }
        let wrapper = target.parentElement;
        if (target.type === 'tel') wrapper = target.closest('div[class*="_formPhoneInputContainer_"]') || wrapper;
        else if (wrapper.parentElement?.tagName === 'DIV' && wrapper.parentElement.querySelectorAll('input').length === 1) wrapper = wrapper.parentElement;
        wrapper.dataset.blockItRepeat = '';
      }
    }
    if (!bound.has(form)) {
      bound.add(form);
      form.addEventListener('input', event => {
        if (pairs.some(([source]) => event.target.id === source)) schedule();
      }, true);
      form.addEventListener('change', event => {
        if (pairs.some(([source]) => event.target.id === source)) schedule();
      }, true);
      form.addEventListener('submit', synchronize, true);
    }
    synchronize();
  }
  let pending = false;
  function refresh() {
    pending = false;
    const hosts = document.querySelectorAll('shopify-forms-embed');
    hosts.forEach(host => {
      if (!host.shadowRoot) return;
      if (!bound.has(host.shadowRoot)) {
        bound.add(host.shadowRoot);
        new MutationObserver(schedule).observe(host.shadowRoot, { childList: true, subtree: true });
      }
      connect(host.shadowRoot);
    });
  }
  function schedule() {
    if (!pending) {
      pending = true;
      requestAnimationFrame(refresh);
    }
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  const poll = setInterval(schedule, 300);
  setTimeout(() => clearInterval(poll), 15000);
  schedule();
})();
